import { replace } from 'lodash';
import { Observable, timeout } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService, HTTP_REQUESTS_TIMEOUT, urls } from 'src/app/core';
import { Voucher } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class VouchersService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  public checkVoucherCode(code: number | string): Observable<Voucher> {
    // const checkVoucherUrl = this.configService.getUrl('discount.checkVoucher');
    const checkVoucherUrl = urls.user.checkDiscountCode;
    const mainUrl = replace(checkVoucherUrl, '{code}', code?.toString());

    return this.http
      .get<Voucher>(mainUrl, { withCredentials: true })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }
}
